import request from '@/utils/request'


//报名列表
export function getProcess (data={}) {
    return request.postJson('/api/schWeb/process/calendar', data)
}
